import { useEffect, useRef, useState, useCallback, useContext } from 'react'
import {ReactFlow, addEdge, Controls, Background, useNodesState, useEdgesState } from '@xyflow/react'
import '@xyflow/react/dist/style.css'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
// import { unstable_usePrompt } from 'react-router-dom'
import {
    REMOVE_DIRTY,
    SET_DIRTY,
    SET_CHATFLOW,
    enqueueSnackbar as enqueueSnackbarAction,
    closeSnackbar as closeSnackbarAction
} from '@/store/actions'
import { NodeMouseHandler } from 'react-flow-renderer';

import { omit, cloneDeep } from 'lodash'
import { useInputData } from '@/store/context/InputDataContext'
import KnowledgeDialog from '@/components/dialog/knowledgeDialog'
// material-ui
// import { useTheme } from '@mui/material/styles'
// project imports
import CanvasNode from './CanvasNode'
import ButtonEdge from './ButtonEdge'
import CanvasHeader from './CanvasHeader'
import AddNodes from './AddNodes'
// import ConfirmDialog from '@/components/dialog/ConfirmDialog'
// import { ChatPopUp } from 'views/chatmessage/ChatPopUp'
import { FlowContext } from '@/store/context/ReactFlowContext'

// API
import nodesApi from '@/api/nodes'
import chatflowsApi from '../../api/chatflows'

// Hooks
import useApi from '@/hooks/useApi'
// import useConfirm from '@/hooks/useConfirm'
import { KnowledgeTag, InputDataItem } from '@/types';

// icons
import { IconPlus, IconX, IconList, IconSquarePlus, IconFiles, IconForms, IconTableShortcut, IconTable, IconArrowForward} from '@tabler/icons-react';

import Template from '@/components/inputComponents/Template';

// utils
import { getUniqueNodeId, initNode, getEdgeLabelName, rearrangeToolsOrdering } from '../../utils/genericHelper';
import { ToolsList } from '@/store/actions'
import useNotifier from '../../utils/useNotifier'

import { FLOWISE_CREDENTIAL_ID } from '../../store/constant'
import  StyledFab  from '../../components/button/StyledFab'
import { AppDispatch, RootState } from '@/store'
const nodeTypes: any = { customNode: CanvasNode }
const edgeTypes: any = { buttonedge: ButtonEdge }
// ==============================|| CANVAS ||============================== //

const AddTool = () => {

    
    const navigate = useNavigate()
    const [open, setOpen] = useState(false);
    const { state } = useLocation()
    const templateFlowData = state?.flowDetails ? state.flowDetails : ''
    const URLpath = document.location.pathname.toString().split('/')
    const chatflowId = URLpath[URLpath.length - 1] === 'addtool' ? '' : URLpath[URLpath.length - 1]
    const { inputData, setInputData } = useInputData();
    const [toolDescription, setToolDescription] = useState('');
    const [enableCron, setEnableCron] = useState('');
    const [tags, setTags] = useState<KnowledgeTag[]>([]);
    const [toolName, setToolName] = useState('New Tool');
    // const { confirm } = useConfirm()

    const dispatch = useDispatch<AppDispatch>()
    const canvas = useSelector((state: RootState) => state.canvas)
    const [canvasDataStore, setCanvasDataStore] = useState(canvas)
    const [addNode, setAddNode] = useState(true)
    const [chatflow, setChatflow] = useState<any>(null)
    const [openInfoFlow, setOpenInfoFlow] = useState(false)
    const { reactFlowInstance, setReactFlowInstance } = useContext(FlowContext)
    const [allNodeData, setAllNodeData] = useState([])
    const [chatOpen, setChatOpen] = useState(false)
    // ==============================|| Snackbar ||============================== //

    
    useNotifier()
    const enqueueSnackbar = (...args: [any]) =>
        dispatch(enqueueSnackbarAction(...args as [any]));
      
    const closeSnackbar = (...args: [any]) =>
        dispatch(closeSnackbarAction(...args as [any]));

    // ==============================|| ReactFlow ||============================== //

    const [nodes, setNodes, onNodesChange] = useNodesState<any>([])
    const [edges, setEdges, onEdgesChange] = useEdgesState<any>([])


    const [selectedNode, setSelectedNode] = useState<any>(null)
    const reactFlowWrapper: any = useRef(null)
    // ==============================|| Chatflow API ||============================== //
  
    const getNodesApi: any = useApi(nodesApi.getAllNodes)
    const createNewChatflowApi: any = useApi(chatflowsApi.createNewChatflow)
    const createNewChatflowVersion = useApi(chatflowsApi.createNewChatflowVersion)
    // const testChatflowApi = useApi(chatflowsApi.testChatflow)
    const updateChatflowApi: any = useApi(chatflowsApi.updateChatflow)
    const getSpecificChatflowApi: any = useApi(chatflowsApi.getSpecificChatflow)

    // ==============================|| Events & Actions ||============================== //
    const onConnect = (params: any) => {
       
        const handleType = params.sourceHandle.split('-')[2]
      
        const newEdge = {
            ...params,
            type: 'buttonedge',
            id: `${params.source}-${params.sourceHandle}-${params.target}-${params.targetHandle}`,
            data: { label: getEdgeLabelName(params.sourceHandle) },
            style:
                handleType === 'control'
                    ? {
                        stroke: 'red',
                        strokeWidth: 3
                    }
                    : {}
        }

        const targetNodeId = params.targetHandle.split('-')[0]
        const sourceNodeId = params.sourceHandle.split('-')[0]
        const targetInput = params.targetHandle.split('-')[2]

        setNodes((nds) =>
            nds.map((node) => {
                if (node.id === targetNodeId) {
                    setTimeout(() => setDirty(), 0)
                    let value
                    const inputAnchor = node.data.inputAnchors.find((ancr) => ancr.name === targetInput)
                    const inputParam = node.data.inputParams.find((param) => param.name === targetInput)

                    if (inputAnchor && inputAnchor.list) {
                        const newValues = node.data.inputs[targetInput] || []
                        if (targetInput === 'tools') {
                            rearrangeToolsOrdering(newValues, sourceNodeId)
                        } else {
                            newValues.push(`{{${sourceNodeId}.data.instance}}`)
                        }
                        value = newValues
                    } else if (inputParam && inputParam.acceptVariable) {
                        value = node.data.inputs[targetInput] || ''
                    } else {
                        value = `{{${sourceNodeId}.data.instance}}`
                    }
                    node.data = {
                        ...node.data,
                        inputs: {
                            ...node.data.inputs,
                            [targetInput]: value
                        }
                    }
                }
                return node
            })
        )

        setEdges((eds) => addEdge(newEdge, eds))
    }
    const handleLoadFlow = (file) => {
        try {
            // const flowData = JSON.parse(file)
            // const nodes = flowData.nodes || []
            // setNodes(nodes)
            // setEdges(flowData.edges || [])
            file?.flowData?.nodes?.forEach((node) => {
                let createNode = { id: node?.id, position: node.flowUi.position, type: 'customNode', data: node?.data }
                setNodes((nds) => nds.concat(createNode))
            })

            file?.flowData?.edges?.forEach((edge) => {
                let createEdge = { id: edge.id, type: edge.type, source: edge.source, target: edge.target, sourceHandle: edge.sourceHandle, targetHandle: edge.targetHandle }
                setEdges((eds) => addEdge(createEdge, eds))
            })
            // setDirty()
        } catch (e) {
            console.error(e)
        }
    }
    const handleDeleteFlow = async () => {
        const confirmPayload = {
            title: `Delete`,
            description: `Delete chatflow ${chatflow.name}?`,
            confirmButtonName: 'Delete',
            cancelButtonName: 'Cancel'
        }
        // const isConfirmed = await confirm(confirmPayload)
        const isConfirmed = true

        if (isConfirmed) {
            try {
                await chatflowsApi.deleteChatflow(chatflow.id)
                navigate(-1)
            } catch (error: any) {
                const errorData = error.response.data || `${error.response.status}: ${error.response.statusText}`
                enqueueSnackbar({
                    message: errorData,
                    options: {
                        key: new Date().getTime() + Math.random(),
                        variant: 'error',
                        persist: true,
                        action: (key) => (
                            <button
                            className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                             style={{ color: 'white' }} onClick={() => closeSnackbar(key)}>
                                <IconX />
                            </button>
                        )
                    }
                })
            }
        }
    }
    const handleSaveFlow = (flowName) => {

        if (reactFlowInstance) {
            const nodes = reactFlowInstance.getNodes().map((node) => {
                const nodeData: any = cloneDeep(node.data)
                if (Object.prototype.hasOwnProperty.call(nodeData.inputs, FLOWISE_CREDENTIAL_ID)) {
                    nodeData.credential = nodeData.inputs[FLOWISE_CREDENTIAL_ID]
                    nodeData.inputs = omit(nodeData.inputs, [FLOWISE_CREDENTIAL_ID])
                }
                node.data = {
                    ...nodeData,
                    selected: false
                }
                return node
            })

            const rfInstanceObject = reactFlowInstance.toObject()
            rfInstanceObject.nodes = nodes
            const flowData = rfInstanceObject

            if (!chatflow.id) {
                const newChatflowBody = {
                    displayName: flowName,
                    deployed: false,
                    isPublic: false,
                    user_id: 1,
                    flowData: {
                        ...flowData,
                        overview: {
                            description: toolDescription  || '',
                            enablecron: enableCron || '',
                        },
                        knowledge: tags,
                        inputData: inputData
                    },

                }

                // createNewChatflowApi.request(newChatflowBody);
                createNewChatflowApi.request(newChatflowBody).then(() => {
                    dispatch(ToolsList()); // Dispatch after successful creation
                });
                
            } else {
                const updateBody = {
                    id: chatflow.id,
                    displayName: flowName,
                    deployed: false,
                    isPublic: false,
                    user_id: 1,
                    flowData: {
                        ...flowData,
                        overview: {
                            description: toolDescription  || '',
                            enablecron: enableCron || '',
                        },
                        knowledge: tags,
                        inputData: inputData
                    },
                }

                updateChatflowApi.request(updateBody).then(() => {
                    dispatch(ToolsList()); // Dispatch after successful creation
                });
            }
            navigate('/tool')
            
        }
    }
  

    const onNodeClick = () => useCallback((event: React.MouseEvent, clickedNode: any) => {
        setSelectedNode(clickedNode);
        setNodes((nds) =>
            nds.map((node) => {
                if (node.id === clickedNode.id) {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            selected: true,
                        },
                    };
                } else {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            selected: false,
                        },
                    };
                }
            })
        );
    }, [setNodes, setSelectedNode]);
    
    
    const onDragOver = useCallback((event) => {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'
    }, [])
    const onDrop = useCallback(
        (event: React.DragEvent<HTMLDivElement>) => {
            event.preventDefault()
         
            const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect()
            
            let nodeData = event.dataTransfer.getData('application/reactflow')
            
            // check if the dropped element is valid
            if (typeof nodeData === 'undefined' || !nodeData) {
                return
            }

            nodeData = JSON.parse(nodeData)

       
            if(!reactFlowInstance) return;
            const position = reactFlowInstance.screenToFlowPosition({
                x: event.clientX - reactFlowBounds.left - 100,
                y: event.clientY - reactFlowBounds.top - 50
            })

            const newNodeId = getUniqueNodeId(nodeData, reactFlowInstance.getNodes())

           
            const newNode = {
                id: newNodeId,
                position,
                type: 'customNode',
                data: initNode(nodeData, newNodeId)
            }


            setSelectedNode(newNode)
            setNodes((nds) =>
                nds.concat(newNode).map((node) => {
                    if (node.id === newNode.id) {
                        node.data = {
                            ...node.data,
                            selected: true
                        }
                    } else {
                        node.data = {
                            ...node.data,
                            selected: false
                        }
                    }

                    return node
                })
            )
            setTimeout(() => setDirty(), 0)
        },

        // eslint-disable-next-line
        [reactFlowInstance]
    )
    const saveChatflowSuccess = () => {
        dispatch({ type: REMOVE_DIRTY })
        enqueueSnackbar({
            message: 'Chatflow saved',
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'success',
                action: (key) => (
                    <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    style={{ color: 'white' }} onClick={() => closeSnackbar(key)}>
                    <IconX />
                    </button>
                )
            }
        })
    }
    const errorFailed = (message) => {
        enqueueSnackbar({
            message,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
                persist: true,
                action: (key) => (
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        style={{ color: 'white' }} onClick={() => closeSnackbar(key)}>
                    <IconX />
                    </button>
                )
            }
        })
    }
    const setDirty = () => {
        dispatch({ type: SET_DIRTY })
    }
    const openChatBox = () => {
        setChatOpen(!chatOpen)
    }
    const infoHandle = () => {
        setOpenInfoFlow(true)
    }
    const agentFlowHandle = () => {
        setOpenInfoFlow(false)
    }
    // ==============================|| useEffect ||============================== //

    // Get specific chatflow successful
    useEffect(() => {
        if (getSpecificChatflowApi.data) {
            const chatflow: any = getSpecificChatflowApi.data
            const initialFlow = chatflow.flowData ? JSON.parse(chatflow.flowData) : []
            setNodes(initialFlow.nodes || [])
            setToolName(chatflow.tool_name || '')
            setEdges(initialFlow.edges || [])
            setInputData(initialFlow.inputData || [])
            setToolDescription(initialFlow.overview?.description || [])
            setEnableCron(initialFlow.overview?.enablecron || [])
            setTags(initialFlow.knowledge || [])
            dispatch({ type: SET_CHATFLOW, chatflow })
        } else if (getSpecificChatflowApi.error) {
            const error: any = getSpecificChatflowApi.error
            const errorData = error.response.data || `${error.response.status}: ${error.response.statusText}`
            errorFailed(`Failed to retrieve chatflow: ${errorData}`)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getSpecificChatflowApi.data, getSpecificChatflowApi.error])

    // Create new chatflow successful
    useEffect(() => {
        if (createNewChatflowApi.data) {
            const chatflow = createNewChatflowApi.data
            dispatch({ type: SET_CHATFLOW, chatflow })
            saveChatflowSuccess()
            if (chatflow) {
                window.history.replaceState(null, `/addtool/${chatflow.id}`);
            }

        } else if (createNewChatflowApi.error) {
            const error: any = createNewChatflowApi.error
            const errorData = error.response.data || `${error.response.status}: ${error.response.statusText}`
            errorFailed(`Failed to save chatflow: ${errorData}`)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createNewChatflowApi.data, createNewChatflowApi.error])

    // Update chatflow successful
    useEffect(() => {
        if (updateChatflowApi.data) {
            dispatch({ type: SET_CHATFLOW, chatflow: updateChatflowApi.data })
            saveChatflowSuccess()
        } else if (updateChatflowApi.error) {
            const error: any = updateChatflowApi.error
            const errorData = error.response.data || `${error.response.status}: ${error.response.statusText}`
            errorFailed(`Failed to save chatflow: ${errorData}`)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateChatflowApi.data, updateChatflowApi.error])

    // Test chatflow failed
    // useEffect(() => {
    //     if (testChatflowApi.error) {
    //         enqueueSnackbar({
    //             message: 'Test chatflow failed',
    //             options: {
    //                 key: new Date().getTime() + Math.random(),
    //                 variant: 'error',
    //                 persist: true,
    //                 action: (key) => (
    //                     <button
    //                     className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
    //                     style={{ color: 'white' }} onClick={() => closeSnackbar(key)}>
    //                         <IconX />
    //                     </button>
    //                 )
    //             }
    //         })
    //     }

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [testChatflowApi.error])

    useEffect(() => setChatflow(canvasDataStore.chatflow), [canvasDataStore.chatflow])

    // Initialization
    useEffect(() => {
        if (chatflowId) {
            getSpecificChatflowApi.request(chatflowId)
        } else {
            if (localStorage.getItem('duplicatedFlowData')) {
                handleLoadFlow(localStorage.getItem('duplicatedFlowData'))
                setTimeout(() => localStorage.removeItem('duplicatedFlowData'), 0)
            } else {
                setNodes([])
                setEdges([])
            }
            dispatch({
                type: SET_CHATFLOW,
                chatflow: {
                    name: 'Untitled chatflow'
                }
            })
        }

        getNodesApi.request()

        // Clear dirty state before leaving and remove any ongoing test triggers and webhooks
        return () => {
            setTimeout(() => dispatch({ type: REMOVE_DIRTY }), 0)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getAllNodeOnclick = () =>{
        getNodesApi.request()
    }

    useEffect(() => {
        setCanvasDataStore(canvas)
    }, [canvas])

    useEffect(() => {
        function handlePaste(e) {
            const pasteData = e.clipboardData.getData('text')
            //TODO: prevent paste event when input focused, temporary fix: catch chatflow syntax
            if (pasteData.includes('{"nodes":[') && pasteData.includes('],"edges":[')) {
                handleLoadFlow(pasteData)
            }
        }

        window.addEventListener('paste', handlePaste)

        return () => {
            window.removeEventListener('paste', handlePaste)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (templateFlowData) {
            handleLoadFlow(templateFlowData)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateFlowData])

    const [activeTab, setActiveTab] = useState('addNode');

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
     const inputRef = useRef<HTMLInputElement>(null); // Change to the appropriate HTML element type
    const [isEditing, setIsEditing] = useState(false);
    const addTag = () => {
        setIsModalOpen(true);
    };

    
    // Type the function parameters
    const handleFileNameChange = (id: string, newFileName: string) => {
      setTags(prevTags =>
        prevTags.map(tag =>
          tag.id === id ? { ...tag, inputName: newFileName } : tag
        )
      );
    };

    const removeTag = (id) => {
        setTags(tags.filter(tag => tag.id !== id));
    };
  
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
                setIsEditing(false);
            }
        };

        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                setIsEditing(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);
  
    const handleToggle = () => {
        setIsEditing(!isEditing);
    };
    // unstable_usePrompt({message: 'You have unsaved changes! Do you want to navigate away?', when: canvasDataStore.isDirty})

    useEffect(() => {
        const nodeData = [
            {
                id: "Input_0",
                displayName: "Input",
                name: "Input",
                version: "1.0.0",
                created: "2024-10-23T05:05:30.298Z",
                updated: "2024-10-23T05:05:30.298Z",
                logoUrl: "https://img.freepik.com/premium-vector/input-output-vector-triangle-arrow-logo-play-media-icon_642210-381.jpg",
                icon: "https://img.freepik.com/premium-vector/input-output-vector-triangle-arrow-logo-play-media-icon_642210-381.jpg",
                category: "Input",
                description: "",
                minimumSupportedRelease: "1.0.0",
                maximumSupportedRelease: "2.0.0",
                controlOutputs: [
                    {
                        label: "default",
                        name: "default",
                        id: "Input_0-output-control-default-default",
                    },
                ],
            },
            {
                id: "Output",
                displayName: "Output",
                name: "Output",
                version: "1.0.0",
                created: "2024-10-23T05:05:30.298Z",
                updated: "2024-10-23T05:05:30.298Z",
                logoUrl: "https://cdn-icons-png.flaticon.com/512/3488/3488340.png",
                icon: "https://cdn-icons-png.flaticon.com/512/3488/3488340.png",
                category: "Output",
                description: "",
                minimumSupportedRelease: "1.0.0",
                maximumSupportedRelease: "2.0.0",
                controlInputs: [
                    {
                        label: "default",
                        name: "default",
                        id: "Output-input-control-default-default",
                    },
                ],
            },
           
        ];
    
        const initialPosition = { x: 50, y: 100 }; // Starting position
        const offsetX = 50; // Horizontal offset between nodes
        const offsetY = 100; // No vertical offset (optional)
    
        // Generate all nodes at once
        const newNodes = nodeData.map((data, index) => {
            const newNodeId = getUniqueNodeId(data, index); // Generate unique 
            return {
                id: newNodeId,
                position: {
                    x: initialPosition.x + index * offsetX, // Increment horizontally
                    y: initialPosition.y + index * offsetY, // Increment vertically
                },
                type: 'customNode',
                data: initNode(data, newNodeId), // Initialize node data
            };
        });
        // Set all nodes at once after the loop
        setNodes((nds) => [...nds, ...newNodes]); // Spread both arrays
    }, []);
    
    return (
        <>
            <div className="rounded-md shadow-md">
                    <div className="border border-lightgrey flex justify-between p-1" >
                        <CanvasHeader 
                            chatflow={chatflow}
                            handleSaveFlow={handleSaveFlow}
                            handleDeleteFlow={handleDeleteFlow}
                            handleLoadFlow={handleLoadFlow}
                            openChatBox={openChatBox}
                            templateFlowData={templateFlowData}
                            agentflowName={state?.agetWorkFlowValue}
                            flowName={toolName}
                            setFlowName={setToolName}
                        />
                    </div>
                
                {/* {openInfoFlow && <div className="box-inline h-screen w-full fixed left-1/5">

                </div>} */}
                <div className='w-full flex'>
                {addNode && !openInfoFlow ? (
                   <div
                   className="h-[calc(100vh-45px)] w-2/6 border-r border-lightgrey flex"
               >
                <div className='w-12 flex flex-col items-center border p-2 cursor-pointer '> 
                    
                    <button className={`hover:ring-blue-500 p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2 ${activeTab === 'addNode' ? 'bg-gray-100': '' }`}
                    onClick={() => handleTabChange('addNode')}
                    ><IconSquarePlus  stroke={1.2} size='1.3rem'/></button>
                                      
                    <button className={`hover:ring-blue-500 hover:bg-gray-100 p-1 mb-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${activeTab === 'overview' ? 'bg-gray-100': '' }`}
                    onClick={() => handleTabChange('overview')}
                    ><IconList  stroke={1.2} size='1.3rem'/></button>

                    <button className={`hover:ring-blue-500 hover:bg-gray-100 p-1 mb-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${activeTab === 'knowledge' ? 'bg-gray-100': '' }`}
                    onClick={() => handleTabChange('knowledge')}
                    ><IconFiles  stroke={1.2} size='1.3rem'/></button>

                    <button className={`hover:ring-blue-500 mb-1 hover:bg-gray-100 p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${activeTab === 'input' ? 'bg-gray-100': '' }`}
                    onClick={() => handleTabChange('input')}
                    ><IconForms  stroke={1.2} size='1.3rem'/></button>

                    <button className={`hover:ring-blue-500 mb-1 hover:bg-gray-100 p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${activeTab === 'output' ? 'bg-gray-100': '' }`}
                    onClick={() => handleTabChange('output')}
                    ><IconTableShortcut  stroke={1.2} size='1.3rem'/></button>
                        
                        
                </div>
                      <div className="p-2 bg-white rounded-md w-full">
                      {activeTab === 'addNode' && (
                       getNodesApi.data && <AddNodes 
                            nodesData={getNodesApi.data} 
                            node={selectedNode} 
                            setAddNode={setAddNode}
                            getAllNodeOnclick={getAllNodeOnclick} 
                        />
                        )}
                        {activeTab === 'overview' && (

                            <>
                            <div className="text-2xl font-bold">Overview</div>
                            

                            <label htmlFor="toolDescription" className="block mb-1 text-sm dark:text-gray-600 text-black">Tool Description</label>
					<input 
					type="text"
					id="toolDescription"
					name="toolDescription"
					className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:border-2"
					placeholder="Tool description"
					value={toolDescription}  // Bind state to input value
                    onChange={(e) => setToolDescription(e.target.value)} 
					/>
                    <label htmlFor="enableCron" className="block mb-1 text-sm dark:text-gray-600 text-black">Enable Cron</label>
					<input 
					type="text"
					id="enableCron"
					name="enableCron"
					className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:border-2"
					placeholder="Enable Cron"
                    value={enableCron}  // Bind state to input value
                    onChange={(e) => setEnableCron(e.target.value)}
					
					/>
                            </>
                        )}
                        {activeTab === 'knowledge' && (

                            <div> 
                            <div className='flex flex-row justify-between mb-2'>
                                <p className='text-lg text-gray font-bold'>Knowledge</p>
                                <button className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-gray-100 focus:border-blue-500 focus:border-2" onClick={addTag}
                    ><IconPlus stroke={1.2} size='1.3rem'/> Add </button>
                            </div>
                                <div className="overflow-y-auto no-scrollbar mt-4 bg-gradient-to-tr" style={{maxHeight: "39rem"}}>
                                    {tags?.map(tag => {
                                        return (
                                            <div key={tag?.id} className='flex bg-gray-100 p-2 rounded-lg mb-3'>
                                        <div className='w-full mr-3 border rounded-lg border-gray-200 border-2 bg-white'>
                                        <div className='border-b p-1 flex items-center space-x-2 max-w-96'>
                                        <IconTable size={16} stroke={1} />
                                        <span className='flex-grow overflow-hidden text-ellipsis whitespace-nowrap'>{tag?.name}</span>
                                    </div>
                                        <div className='p-1 flex items-center space-x-2'>
                                            <IconArrowForward  size={20} stroke={0.5}/>
                                            <div className='flex items-center space-x-2 max-w-96'>
                                            <span className='flex-grow text-sm'>knowledge.</span>
                                            {isEditing ? (
                                                <div style={{ display: 'inline-block', maxWidth: '24rem' }}>
                                                    <input
                                                        type='text'
                                                        className='bg-green-100/75 px-1 rounded-md text-sm cursor-text overflow-hidden focus:outline-none focus:border-ring-500 focus:border-2'
                                                        value={tag?.inputName || ''}
                                                        onChange={(e) => handleFileNameChange(tag.id, e.target.value)}
                                                        style={{ minWidth: '0', maxWidth: '18rem' }}
                                                    />
                                                </div>
                                            ) : (
                                                <span 
                                                onClick={handleToggle} 
                                                className="bg-green-100/75 px-1 rounded-md text-sm flex-grow overflow-hidden text-ellipsis whitespace-nowrap"
                                                >
                                                {tag?.inputName}
                                                </span>

                                            )}
                                            </div>
                                            </div> 
                                        </div>
                                        <IconX size={18} style={{ cursor: 'pointer' }} onClick={() => removeTag(tag?.id)} />
                                    </div>
                                )} )}
                                </div>
                            
                            <KnowledgeDialog
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                setTags={setTags}
                                tags={tags}
                                flowData={''}
                                setFlowData={''}
                            />
                            </div>
                        )}
                        {activeTab === 'input' && (
                            
                            <div> 

                    <Template inputData={inputData} setInputData={setInputData} className="max-h-[calc(100vh-250px)]" />
                            
                        </div>
                            
                        )}
                        {activeTab === 'output' && (
                            <div>Output</div>
                        )}
                        </div>
                    </div>

                ) : !openInfoFlow && (
                    <div className="fixed z-[300]">
                            <IconPlus onClick={() => {
                                setAddNode(true)
                            }} /> Add Nodes
                    </div>
                )}
                {
                    !openInfoFlow && <div className="h-[calc(100vh-45px)] w-4/5 ">
                        <div className='reactflow-parent-wrapper'>
                            <div className='reactflow-wrapper' ref={reactFlowWrapper}>
                                <ReactFlow
                                    nodes={nodes}
                                    edges={edges}
                                    onNodesChange={onNodesChange}
                                    onNodeClick={onNodeClick}
                                    onEdgesChange={onEdgesChange}
                                    onDrop={onDrop}
                                    onDragOver={onDragOver}
                                    onNodeDragStop={setDirty}
                                    nodeTypes={nodeTypes}
                                    edgeTypes={edgeTypes}
                                    onConnect={onConnect}
                                    onInit={setReactFlowInstance}
                                    fitView
                                    deleteKeyCode={canvas.canvasDialogShow ? null : ['Backspace', 'Delete']}
                                    minZoom={0.1}
                                    maxZoom={1.2}
                                >
                                    <Controls />
                                    <Background color="#aaa" gap={16} />
                                
                                </ReactFlow>
                            </div>
                        </div>
                    </div>
                }
                </div>
                
            </div>
        </>
    )
}

export default AddTool
